import React from 'react';
import { Star, Stars, Sparkles } from 'lucide-react';
import { StepButtons } from '../ui';

interface FinishingStepProps {
  value: {
    finishingLevel: 'economic' | 'standard' | 'premium' | null;
  };
  onChange: (field: string, value: any) => void;
  onNext: () => void;
  onBack: () => void;
}

export const FinishingStep: React.FC<FinishingStepProps> = ({
  value,
  onChange,
  onNext,
  onBack
}) => {
  const handleLevelSelect = (level: 'economic' | 'standard' | 'premium') => {
    onChange('finishingLevel', level);
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold text-primary">Niveau de finition</h2>
      
      <div className="grid grid-cols-3 gap-4">
        <FinishingCard
          icon={<Star className="h-8 w-8" />}
          type="economic"
          label="Économique"
          description="Matériaux basiques, finitions simples"
          selected={value.finishingLevel === 'economic'}
          onClick={() => handleLevelSelect('economic')}
        />
        <FinishingCard
          icon={<Stars className="h-8 w-8" />}
          type="standard"
          label="Standard"
          description="Bon rapport qualité/prix"
          selected={value.finishingLevel === 'standard'}
          onClick={() => handleLevelSelect('standard')}
        />
        <FinishingCard
          icon={<Sparkles className="h-8 w-8" />}
          type="premium"
          label="Haut de gamme"
          description="Matériaux nobles, finitions soignées"
          selected={value.finishingLevel === 'premium'}
          onClick={() => handleLevelSelect('premium')}
        />
      </div>

      <StepButtons
        onNext={onNext}
        onBack={onBack}
        disabled={!value.finishingLevel}
      />
    </div>
  );
};

interface FinishingCardProps {
  icon: React.ReactNode;
  type: string;
  label: string;
  description: string;
  selected: boolean;
  onClick: () => void;
}

const FinishingCard: React.FC<FinishingCardProps> = ({
  icon,
  label,
  description,
  selected,
  onClick
}) => (
  <button
    type="button"
    onClick={onClick}
    className={`
      card flex flex-col items-center p-6 transition-all
      ${selected ? 'ring-2 ring-primary bg-primary/5' : 'hover:bg-neutral-50'}
    `}
  >
    <div className={`mb-4 ${selected ? 'text-primary' : 'text-neutral-600'}`}>
      {icon}
    </div>
    <span className={`font-medium mb-2 ${selected ? 'text-primary' : 'text-neutral-700'}`}>
      {label}
    </span>
    <p className="text-sm text-neutral-500 text-center">
      {description}
    </p>
  </button>
);

export default FinishingStep;